import React from 'react';

import './style.scss';
import Breadcrumbs from "../Breadcrumb";
import NavBarTwo, { parentInterface } from "../NavBarTwo";
import { useLocation } from "react-router-dom";

interface propsInterface {
  title: string | null | undefined;
  breadcrumbs?: any;
  children?: React.ReactNode;
  className?: string;
  align?: 'right' | 'left' | 'center';
  navs?: {[index: number]: any};
  parent?: parentInterface;
  activeId?: number;
}

const PageHeader = (
  {
    title,
    breadcrumbs,
    children,
    className,
    align,
    navs,
    parent,
    activeId
  }: propsInterface
) => {
  const { pathname }  = useLocation();
  let extraClassName = 'o-body';
  extraClassName += align ? ` o-${align}` : '';

  function getActiveId() {
    if(!navs) {
      return;
    }

    if(activeId) {
      return activeId;
    }

    return Object.values(navs).find(e => e.url === pathname)?.id;
  }

  return (
    <div className={`v-page-header ${className}`}>
      <div className='o-top'>
        { breadcrumbs && <Breadcrumbs items={breadcrumbs}/> }
        <h2 className='o-title'>{title}</h2>
      </div>

      <div className={extraClassName}>
        {
          navs && (
            <NavBarTwo
              items={navs}
              itemIds={Object.keys(navs)}
              activeId={getActiveId()}
              parent={parent}
            />
          )
        }
        {children}
      </div>
    </div>
  );
}

export default PageHeader;
